import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DepositoEfectivoService } from 'src/app/services/deposito-efectivo.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'
import { ToastService } from 'ng-uikit-pro-standard';
import { DatesService } from 'src/app/shared/services/dates.service';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { ModalDepositoDetalleComponent } from './modal-deposito-detalle/modal-deposito-detalle.component';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'app-timbrar-deposito',
  templateUrl: './timbrar-deposito.component.html',
  styleUrls: ['./timbrar-deposito.component.scss'],
  providers: [SecurityService]
})
export class TimbrarDepositoComponent implements OnInit {

  // Form
  formHeader: FormGroup

  // Modals
  @ViewChild(ModalDepositoDetalleComponent, { static: true }) modalVerDetalle: ModalDepositoDetalleComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @Output() onClienteChange: EventEmitter<any> = new EventEmitter<any>()

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  loading: boolean = false
  listaDepositosAll: any[] = null
  listaDepositos: any[] = null
  checkAll: boolean = false
  paginationContext: PaginationContext = new PaginationContext()
  clienteSeleccionado: any = null
  headerData: any = {}

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private depositoEfectivoService: DepositoEfectivoService,
    private depositoDocumentoService: DepositoDocumentoService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private rutService: RutService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('TIMBRAR-DEPOSITO-EFECTIVO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10

    this.createForm()
    this.formChangesSubscriptions()
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
        this.modalSeleccionarCliente.cleanLast()
      })
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      rutCliente: [null],
      nroDoc: [null],
      nroDeposito: [null],
      porTimbrar: true,
      timbrados: true,
      filtroMonto: [null]
    });
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaDepositos = null
    this.checkAll = false
    this.loading = true

    const inputParams = {
      entidad: {
        empresa_rut: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
        cliente_proveedor_rut: Number(this.clienteSeleccionado === null ? 0 : this.clienteSeleccionado.rut),
        numero_doc: Number(this.formHeader.get('nroDoc').value !== null ? this.formHeader.get('nroDoc').value : 0),
        numero_deposito: Number(this.formHeader.get('nroDeposito').value !== null ? this.formHeader.get('nroDeposito').value : 0),
        timbrados: this.formHeader.get('timbrados').value,
        porTimbrar: this.formHeader.get('porTimbrar').value,
        filtroMonto: Number(this.formHeader.get('filtroMonto').value === null ? 0 : this.formHeader.get('filtroMonto').value),
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, // this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))
    this.depositoDocumentoService.obtenerDepositoTimbrarSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      let ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = registros.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1
      this.listaDepositosAll = registros
      this.listaDepositosAll.forEach((deposito, index) => {
        delete deposito.__typename
        deposito.additionalData = {}
        deposito.additionalData.seleccion = false
        deposito.additionalData.index = index
        deposito.additionalData.depositanteRutFormato = this.rutService.AgregarDV(deposito.depositante_rut)
      });

      this.loading = false
      this.showPage(1)
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaDepositos = _.slice(this.listaDepositosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  checkAllChange({ checked }) {
    this.listaDepositosAll.filter(p => p.activo).forEach(detalle => { detalle.additionalData.seleccion = checked })
    this.listaDepositos.filter(p => p.activo).forEach(detalle => { detalle.additionalData.seleccion = checked })
    this.checkAll = checked
  }

  checkDetalle({ additionalData }) {
    const { index, seleccion } = additionalData

    const selectedMain: any = this.listaDepositosAll.filter((detalle: any) => detalle.additionalData.index === index)[0]
    selectedMain.additionalData.seleccion = !seleccion

    const selected: any = this.listaDepositos.filter((detalle: any) => detalle.additionalData.index === index)[0]
    selected.additionalData.seleccion = !seleccion

    const totalUnselected: number = this.listaDepositosAll.filter((detalle: any) => !detalle.additionalData.seleccion).length
    this.checkAll = totalUnselected === 0
  }

  verDetalle(deposito) {
    this.modalVerDetalle.load(deposito)
  }

  timbrar() {
    let lista: any[] = _.cloneDeep(this.listaDepositosAll)
    lista = lista.filter(deposito => deposito.additionalData.seleccion)
    if (lista.length === 0) {
      this.toastService.warning('Seleccione un depósito')
      return
    }

    lista.forEach(deposito => {
      deposito.seleccion = deposito.additionalData.seleccion
      delete deposito.additionalData
    });

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        lista
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }

    this.log(JSON.stringify(inputParams))

    this.depositoDocumentoService.guardarTimbradoDeposito(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastService.success('Operación realizada')
      this.buscar(1)
    })
  }

  openModalSeleccionarClientes() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut)
    this.formHeader.get('rutCliente').setValue(this.clienteSeleccionado.rutFormato)
    this.onClienteChange.emit(this.headerData.clienteSeleccionado)
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
    this.clearClientData()
  }
  clearClientData() {
    this.clearContent()
    this.onClienteChange.emit(null)
  }
  clearContent() {
    this.headerData = {}
    // this.formValidatorsService.reset(this.formHeader)
  }

  limpiarData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.reset();
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get("rutCliente").setValue(null)
    this.formHeader.get("nroDoc").setValue(null)
    this.formHeader.get("filtroMonto").setValue(null)
    this.formHeader.get("nroDeposito").setValue(null)
    this.formHeader.get("porTimbrar").setValue(true)
    this.formHeader.get("timbrados").setValue(true)
    this.clienteSeleccionado = null

    this.listaDepositos = null
    this.listaDepositosAll = null
  }

}
